// import _ from "lodash";
import groupBy from 'lodash/groupBy'

async function checkVincols(cartSettings, bet, allowIntegralLiveBet = false) {
  return new Promise(async (resolve, reject) => {
    const errors = []
    const warnings = []
    const errorsMultInfo = []

    const checkCartTypeVincols = await cartTypeVincols(
      cartSettings,
      bet,
      allowIntegralLiveBet
    )
    if (checkCartTypeVincols.length > 0) {
      errors.push(...checkCartTypeVincols)
    }

    const checkCartContextVincols = await cartContextVincols(cartSettings, bet)
    if (checkCartContextVincols.length > 0) {
      errors.push(...checkCartContextVincols)
    }

    if (bet.type == 'system') {
      // TODO system checkVincols

      var checkAmountVincols = await amountVincols(
        bet,
        cartSettings.minAmount,
        cartSettings.live_min_amount,
        cartSettings.live_max_amount,
        cartSettings.prematch_max_amount
      )
      if (checkAmountVincols.length > 0) {
        errors.push(...checkAmountVincols)
      }

      if (bet.odds.length > 10) {
        errors.push({ message: 'maximumOddsSystem' })
      }
    } else {
      const checkMultiplicityVincols = await multiplicityVincols(bet)
      if (checkMultiplicityVincols.length > 0) {
        errors.push(...checkMultiplicityVincols)
      }

      var checkAmountVincols = await amountVincols(
        bet,
        cartSettings.minAmount,
        cartSettings.live_min_amount,
        cartSettings.live_max_amount,
        cartSettings.prematch_max_amount
      )
      if (checkAmountVincols.length > 0) {
        errors.push(...checkAmountVincols)
      }

      const checkMultiplicityVincolsInfo = await multiplicityVincolsInfo(bet)
      if (checkMultiplicityVincolsInfo.length > 0) {
        errorsMultInfo.push(...checkMultiplicityVincolsInfo)
      }
    }

    const checkFlattening = await flattening(
      bet,
      cartSettings.max_winning,
      cartSettings.max_odds,
      cartSettings.live_max_winning
    )
    if (checkFlattening.length > 0) {
      warnings.push(...checkFlattening)
    }

    const checkMulitplicityTotal = await checkMultiplicityTotal(
      bet,
      cartSettings.live_max_multiplicity
    )
    if (checkMulitplicityTotal.length > 0) {
      errors.push(...checkMulitplicityTotal)
    }

    resolve({
      warnings: warnings,
      errors: errors,
      check: errors.length == 0,
      errors_multi_info: errorsMultInfo,
    })
  })
}

async function cartTypeVincols(cartSettings, bet, allowIntegralLive = false) {
  return new Promise(async (resolve, reject) => {
    const errors = []

    if (!cartSettings.single && bet.type == 'single') {
      errors.push({
        message: 'singleNotAllowed',
      })
    } else if (!cartSettings.multiple && bet.type == 'multiple') {
      errors.push({
        message: 'multipleNotAllowed',
      })
    } else if (bet.type == 'integral') {
      if (allowIntegralLive === true) {
        if (!cartSettings.integral) {
          errors.push({
            message: 'integralNotAllowed',
          })
        }
      } else {
        if (
          !cartSettings.integral ||
          bet.context == 'live' ||
          bet.context == 'mixed'
        ) {
          errors.push({
            message: 'integralNotAllowed',
          })
        }
      }
    } else if (
      (!cartSettings.system && bet.type == 'system') ||
      ((bet.context == 'live' || bet.context == 'mixed') &&
        bet.type == 'system')
    ) {
      errors.push({
        message: 'systemNotAllowed',
      })
    }

    resolve(errors)
  })
}

async function cartContextVincols(cartSettings, bet) {
  return new Promise(async (resolve, reject) => {
    const errors = []

    if (
      (bet.context == 'live' || bet.context == 'mixed') &&
      !cartSettings.enableLive
    ) {
      errors.push({
        message: 'liveNotEnabled',
      })
    }

    const odds = JSON.parse(JSON.stringify(bet.odds))

    const grouped_odds = groupBy(odds, 'type')

    const types = Object.keys(grouped_odds)

    if (types.length > 1) {
      if (types.includes('antepost')) {
        errors.push({
          message: 'antepostCombinabilityNotAllowed',
        })
      }

      resolve(errors)
    } else {
      resolve(errors)
    }
  })
}

async function amountVincols(
  bet,
  minAmount,
  live_min_amount,
  live_max_amount,
  prematch_max_amount
) {
  return new Promise(async (resolve, reject) => {
    const errors = []
    let amount = 0

    if (bet.type == 'single' || bet.type == 'multiple') {
      amount = +bet._multiple_detail.amount
    } else if (bet.type == 'integral') {
      amount = +bet._integral_detail.amount
    } else if (bet.type == 'system') {
      amount = +bet._system_detail.amount_system
    }

    if (bet.context == 'prematch') {
      if (minAmount != undefined && minAmount > 0 && amount < +minAmount) {
        errors.push({
          message: 'minimumAmountNotRespected',
          value: +minAmount,
        })
      }

      if (
        prematch_max_amount != null &&
        +prematch_max_amount > 0 &&
        amount > +prematch_max_amount
      ) {
        errors.push({
          message: 'maximumAmountNotRespected',
          value: +prematch_max_amount,
        })
      }
    } else if (bet.context == 'mixed' || bet.context == 'live') {
      if (
        +live_min_amount != undefined &&
        +live_min_amount > 0 &&
        amount < +live_min_amount
      ) {
        errors.push({
          message: 'minimumAmountNotRespected',
          value: +live_min_amount,
        })
      }

      if (
        +live_max_amount != undefined &&
        +live_max_amount > 0 &&
        amount > +live_max_amount
      ) {
        errors.push({
          message: 'maximumAmountNotRespected',
          value: +live_max_amount,
        })
      }
    }

    resolve(errors)
  })
}

async function multiplicityVincols(bet) {
  return new Promise(async (resolve, reject) => {
    const errors = []
    let multiplicity = 0
    if (bet.type == 'single' || bet.type == 'multiple') {
      multiplicity = +bet._multiple_detail.multiplicity
    } else if (bet.type == 'integral') {
      multiplicity = +bet._integral_detail.multiplicity
    }

    for (const odd of bet.odds) {
      if (
        !(
          multiplicity >= +odd.multiplicity_min &&
          multiplicity <= +odd.multiplicity_max
        )
      ) {
        errors.push({
          message: odd.event_description + '#multiplicity_not_respected',
        })
      }
    }

    resolve(errors)
  })
}

async function multiplicityVincolsInfo(bet) {
  return new Promise(async (resolve, reject) => {
    const errors = []
    let multiplicity = 0
    if (bet.type == 'single' || bet.type == 'multiple') {
      multiplicity = +bet._multiple_detail.multiplicity
    } else if (bet.type == 'integral') {
      multiplicity = +bet._integral_detail.multiplicity
    }

    let multi_minimum = 0

    for (const odd of bet.odds) {
      if (odd.multiplicity_min > multi_minimum) {
        multi_minimum = odd.multiplicity_min
      }
    }

    if (multiplicity < multi_minimum) {
      errors.push({
        message: 'multiplicity_info_' + multi_minimum,
      })
    }

    resolve(errors)
  })
}

async function flattening(
  bet,
  prematch_max_winning,
  prematch_max_odds,
  live_max_winning
) {
  return new Promise(async (resolve, reject) => {
    const warnings = []

    const errorMaxWinning = { message: 'max_winning_reached' }
    const errorMaxOdds = { message: 'max_odds_reached' }

    if (bet.context == 'prematch') {
      switch (bet.type) {
        case 'single':
        case 'multiple':
          if (
            prematch_max_winning != undefined &&
            +prematch_max_winning > 0 &&
            bet._multiple_detail.winning_total > +prematch_max_winning
          ) {
            bet._multiple_detail.winning_total = +prematch_max_winning
            errorMaxWinning.value = +prematch_max_winning
            warnings.push(errorMaxWinning)
          }
          if (
            prematch_max_odds != undefined &&
            +prematch_max_odds > 0 &&
            bet._multiple_detail.odds_total > +prematch_max_odds
          ) {
            bet._multiple_detail.odds_total = +prematch_max_odds
            errorMaxOdds.value = +prematch_max_odds
            warnings.push(errorMaxOdds)
          }
          break
        case 'integral':
          if (
            prematch_max_winning != undefined &&
            +prematch_max_winning > 0 &&
            bet._integral_detail.winning_total_max > +prematch_max_winning
          ) {
            bet._integral_detail.winning_total_max = +prematch_max_winning
            errorMaxWinning.value = +prematch_max_winning
            warnings.push(errorMaxWinning)
          }
          if (
            prematch_max_odds != undefined &&
            +prematch_max_odds > 0 &&
            bet._integral_detail.odds_total_max > +prematch_max_odds
          ) {
            bet._integral_detail.odds_total_max = +prematch_max_odds
            errorMaxOdds.value = +prematch_max_odds
            warnings.push(errorMaxOdds)
          }
          break
        case 'system':
          if (
            prematch_max_winning != undefined &&
            +prematch_max_winning > 0 &&
            bet._system_detail.winning_total_max > +prematch_max_winning
          ) {
            bet._system_detail.winning_total_max = +prematch_max_winning
            errorMaxWinning.value = +prematch_max_winning
            warnings.push(errorMaxWinning)
          }
          break
      }
    } else if (bet.context == 'live' || bet.context == 'mixed') {
      switch (bet.type) {
        case 'single':
        case 'multiple':
          if (
            live_max_winning != undefined &&
            +live_max_winning > 0 &&
            bet._multiple_detail.winning_total > +live_max_winning
          ) {
            bet._multiple_detail.winning_total = +live_max_winning
            errorMaxWinning.value = +live_max_winning
            warnings.push(errorMaxWinning)
          }
          break
        case 'integral':
          if (
            live_max_winning != undefined &&
            +live_max_winning > 0 &&
            bet._integral_detail.winning_total_max > +live_max_winning
          ) {
            bet._integral_detail.winning_total_max = +live_max_winning
            errorMaxWinning.value = +live_max_winning
            warnings.push(errorMaxWinning)
          }
          break
        case 'system':
          if (
            live_max_winning != undefined &&
            +live_max_winning > 0 &&
            bet._system_detail.winning_total_max > +live_max_winning
          ) {
            bet._system_detail.winning_total_max = +live_max_winning
            errorMaxWinning.value = +live_max_winning
            warnings.push(errorMaxWinning)
          }
          break
      }
    }

    resolve(warnings)
  })
}

async function checkMultiplicityTotal(bet, live_max_multiplicity) {
  return new Promise(async (resolve, reject) => {
    const errors = []

    if (bet.context == 'prematch') {
      //
    } else if (bet.context == 'live' || bet.context == 'mixed') {
      switch (bet.type) {
        case 'single':
        case 'multiple':
          if (
            live_max_multiplicity != undefined &&
            +live_max_multiplicity > 0 &&
            +bet._multiple_detail.multiplicity > +live_max_multiplicity
          ) {
            errors.push({ message: 'max_multiplicity_not_respected' })
          }
          break
        case 'integral':
          if (
            live_max_multiplicity != undefined &&
            +live_max_multiplicity > 0 &&
            +bet._integral_detail.multiplicity > +live_max_multiplicity
          ) {
            errors.push({ message: 'max_multiplicity_not_respected' })
          }
          break
        case 'system':
          break
      }
    }

    resolve(errors)
  })
}

export default {
  checkVincols,
}
